export type EmploymentSituation =
  'FULLTIMEPERMANENT' |
  'UNEMPLOYED' |
  'SELFEMPLOYED' |
  'STUDENT' |
  'PARTTIME' |
  'AGENCY' |
  'RETIRED' |
  'SUBCONTRACT' |
  'TEMPORARY' |
  'DISABILITY' |
  'CARER'

export const mapEmploymentSituation = (situation: string): EmploymentSituation => {
  switch (situation.toLowerCase()) {
    case 'full time permanent':
      return 'FULLTIMEPERMANENT'
    case 'self employed':
      return 'SELFEMPLOYED'
    case 'not employed':
      return 'UNEMPLOYED'
    case 'student':
      return 'STUDENT'
    case 'part time':
      return 'PARTTIME'
    case 'agency':
      return 'AGENCY'
    case 'retired':
      return 'RETIRED'
    case 'sub contractor':
      return 'SUBCONTRACT'
    case 'temporary':
      return 'TEMPORARY'
    case 'armed forces':
      return 'FULLTIMEPERMANENT'
    case 'disability':
      return 'DISABILITY'
    case 'homemaker':
      return 'UNEMPLOYED'
    case 'carer':
      return 'CARER'
    case 'other':
      return 'FULLTIMEPERMANENT'
    default:
      return 'FULLTIMEPERMANENT'
  }
}
